import {
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  Aperture,
  Check,
  Copy,
  Globe,
  Image,
  Images,
  Info,
  Layers,
  Mail,
  Menu,
  Save,
  Settings,
  Share2,
  ShieldCheck,
  Sparkles,
  Sun,
  Video,
  Wand2,
  X,
  type LucideIcon
} from "lucide-react";

const registry: Record<string, LucideIcon> = {
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  "arrow-up-right": ArrowUpRight,
  aperture: Aperture,
  check: Check,
  copy: Copy,
  globe: Globe,
  image: Image,
  images: Images,
  info: Info,
  layers: Layers,
  mail: Mail,
  menu: Menu,
  save: Save,
  settings: Settings,
  "share-2": Share2,
  "shield-check": ShieldCheck,
  sparkles: Sparkles,
  sun: Sun,
  video: Video,
  wand: Wand2,
  x: X
};

type IconProps = {
  name: string;
  size?: number;
  className?: string;
  strokeWidth?: number;
};

export function Icon({ name, size = 20, className, strokeWidth = 2 }: IconProps) {
  const Component = registry[name] ?? Aperture;
  return <Component size={size} className={className} strokeWidth={strokeWidth} aria-hidden="true" />;
}
